<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="loading" />
					<div v-if="!loading" class="navbar-text nav-title flex" id="pageTitle">Roles</div>
				</div>

				<div class="content-main" style="background-color: white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="!loading">
						<div class="d-sm-flex b-t h-100">
							<edit-pane :cancel="loadData" :save="saveClient" :dirty="dirty" :valid="valid">
								<!-- ROLES -->
								<!-- <div id="tab-4"> -->
								<div class="row m-0">
									<form role="form" class="p-4 col-md-6">
										<p>Select a role to configure permissions</p>
										<div class="list-group box">
											<a
												v-for="(role, i) in orderedRoles"
												:key="role.id"
												@click="sRole = role"
												:class="{
													'text-danger': isDuplicate(role, i),
													'text-white': !isDuplicate(role, i) && isRoleActive(role),
													primary: isRoleActive(role),
												}"
												class="list-group-item d-flex flex-row align-items-center"
											>
												<!-- <span class="float-right">
                                                            <i class="fa fa-chevron-right"></i>
												</span>-->
												<span>{{ role.name }} ({{ role.access }})</span>
												<i
													class="flex ml-1 valid-hint text fa fa-angle-left"
													:class="{ invalid: isDuplicate(role, i) }"
												></i>
												<span v-if="user.role.access >= role.access" @click="removeRole(role)">
													<i class="fa fa-trash text-danger"></i>
												</span>
												<span v-if="user.role.access < role.access">
													<i class="fa fa-trash text-extra-muted"></i>
												</span>
											</a>
										</div>
										<button type="button" @click="addRole()" class="btn green btn btn-block">
											<i class="fa fa-plus"></i> Add Role
										</button>
									</form>
									<form
										role="form"
										class="p-4 col-md-6"
										:class="{ 'text-muted': !hasAccess(sRole) }"
										v-if="sRole"
									>
										<div class="form-group">
											<label>Role Name</label>
											<input
												type="text"
												v-model="sRole.name"
												class="form-control"
												:disabled="!hasAccess(sRole)"
											/>
										</div>
										<div class="form-group">
											<label>Reference ID</label>
											<input
												type="text"
												v-model.trim="sRole.id"
												class="form-control"
												:disabled="!hasAccess(sRole) || !sRole.new"
											/>
										</div>
										<div class="row form-group">
											<div :class="{ [sRole.allow_registration ? 'col-6' : 'col-12']: true }">
												<label>Access Level</label>
												<input
													type="number"
													v-model.number="sRole.access"
													class="form-control"
													:disabled="!hasAccess(sRole)"
												/>
											</div>
											<div v-if="sRole.allow_registration" class="col-6">
												<label>
													Display Sequence
													<small class="text-muted">(in registration)</small>
												</label>
												<input
													type="number"
													v-model.number="sRole.sequence"
													class="form-control"
													:disabled="!hasAccess(sRole)"
												/>
											</div>
										</div>
										<div class="form-group">
											<label>Theme</label>
											<theme-select
												:themes="themes"
												v-model="sRole.theme"
												:disabled="!hasAccess(sRole)"
											></theme-select>
										</div>
										<div class="row">
											<div class="col-md-6">
												<div>
													<p>Main Page</p>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.teacher_entry"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Teacher Section
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.scorer_entry"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Scoring Section
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.reporting_entry"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Reporting Section
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.admin_entry"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Configuration Section
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_create_from_template"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> My Assessments
														</label>
													</div>
												</div>

												<hr class="mt-0 mb-3" />

												<div>
													<p>Other Settings</p>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.allow_registration"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Allow Registration as this Role
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.show_help"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i>
															Show Help Link
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.show_score_count"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Show Count While Scoring
														</label>
													</div>
													<!-- <hr class="mt-0 mb-3">
															<div class="checkbox form-group">
																<label class="md-check">
																	<input v-model="sRole.video_and_chat" type="checkbox" :disabled="!hasAccess(sRole)">
																	<i class="theme-accent"></i> Video and Chat
																</label>
													</div>-->
												</div>

												<div v-if="sRole.page_config_users" class="checkbox form-group">
													<label class="md-check">
														<input
															v-model="sRole.receive_reg_emails"
															type="checkbox"
															:disabled="!hasAccess(sRole)"
														/>
														<i class="theme-accent"></i> Receive New Registration Emails
													</label>
												</div>
												<div class="checkbox form-group">
													<label class="md-check">
														<input
															v-model="sRole.receive_resp_emails"
															type="checkbox"
															:disabled="!hasAccess(sRole)"
														/>
														<i class="theme-accent"></i> Receive Oustanding Work Emails
													</label>
												</div>
												<div class="checkbox form-group">
													<label class="md-check">
														<input
															v-model="sRole.comment_on_complete"
															type="checkbox"
															:disabled="!hasAccess(sRole)"
														/>
														<i class="theme-accent"></i> Comment on Completed Responses
													</label>
												</div>
												<div class="checkbox form-group">
													<label class="md-check">
														<input
															v-model="sRole.escalate_exemplars"
															type="checkbox"
															:disabled="!hasAccess(sRole)"
														/>
														<i class="theme-accent"></i> Escalate Exemplars
													</label>
												</div>
												<div class="checkbox form-group">
													<label class="md-check">
														<input
															v-model="sRole.allow_print"
															type="checkbox"
															:disabled="!hasAccess(sRole)"
														/>
														<i class="theme-accent"></i> Print Responses
													</label>
												</div>
												<div class="checkbox form-group">
													<label class="md-check">
														<input
															v-model="sRole.moderate_bank_comments"
															type="checkbox"
															:disabled="!hasAccess(sRole)"
														/>
														<i class="theme-accent"></i> Moderate Taskbank Comments
													</label>
												</div>
											</div>
											<div class="col-md-6">
												<div v-if="sRole.teacher_entry">
													<p>Teacher Settings</p>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.manage_classes"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Manage Classes
														</label>
													</div>
													<hr class="mt-0 mb-3" />
												</div>
												<div v-if="sRole.scorer_entry">
													<p>Scoring Settings</p>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.second_score"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Second Score
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.resolution_score"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Resolution Score
														</label>
													</div>
													<hr class="mt-0 mb-3" />
												</div>
												<div v-if="sRole.reporting_entry">
													<p>Reporting Settings</p>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_auditing"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Auditing
														</label>
													</div>
													<div class="checkbox form-group" v-if="sRole.page_auditing">
														<label class="md-check">
															<input
																v-model="sRole.delete_data"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Delete Scores & Responses
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_school_dashboard"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> School Dashboard
														</label>
													</div>
													<div
														v-if="sRole.page_school_dashboard"
														class="form-group"
														style="margin-top: -0.5rem"
													>
														<label>School Dashboard Access Level</label>
														<config-select
															:options="schoolDashAccessLevels"
															v-model="sRole.school_dash_access_level"
															byField="id"
															sortBy="sequence"
														/>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_traffic_dashboard"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Traffic Dashboard
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_report_completion"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Completion Report
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_report_scorers"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Scorers Reports
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_asmt_summary"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Assessment Stats
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_user_agreement"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> User Agreement
														</label>
													</div>
													<hr class="mt-0 mb-3" />
												</div>
												<div v-if="sRole.admin_entry">
													<p>Configuration Settings</p>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_current_tenant"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Tenant Config
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_districts"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> District Setup
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_schools"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> School Setup
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_classes"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Class Listing
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_courses"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Course Listing
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_students"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Student Listing
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_content_areas"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Content Area Setup
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_assessments"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Assessment Setup
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_assign_assessments"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Assessment Assign
														</label>
													</div>

													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_approve_assessment"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Assessment Approval
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_create_template"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Create Template
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_items"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Item Setup
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_rubrics"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Rubric Setup
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_users"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> User Setup
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_teams"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Team Setup
														</label>
													</div>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.page_config_standards"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Standard Setup
														</label>
													</div>
													<hr class="mt-0 mb-3" />
												</div>
												<div v-if="sRole.page_supervisor_dashboard || sRole.page_reporting">
													<p v-if="sRole.page_supervisor_dashboard && !sRole.page_reporting">
														Dashboard Permissions
													</p>
													<p v-if="!sRole.page_supervisor_dashboard && sRole.page_reporting">
														Reporting Permissions
													</p>
													<p v-if="sRole.page_supervisor_dashboard && sRole.page_reporting">
														Reporting/Dashboard
													</p>
													<div class="checkbox form-group">
														<label class="md-check">
															<input
																v-model="sRole.limit_teams"
																type="checkbox"
																:disabled="!hasAccess(sRole)"
															/>
															<i class="theme-accent"></i> Limit to Own Teams
														</label>
													</div>
													<hr class="mt-0 mb-3" />
												</div>
											</div>
										</div>
									</form>
								</div>
							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveClient"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="Tenant"
								:objectName="client.name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>

							<save-required-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveClient"
								:next="saveReqNext"
								objectText="Tenant"
								:objectName="client.name"
								:actionText="saveReqAction"
								v-model="saveReqModal"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-auto {
	z-index: -1;
}
.w30 {
	width: 30px;
}
</style>

<script>
//Libraries
import notie from "@/services/NotieService";

//Services
import TenantService from "@/services/TenantService";
import AuthService from "@/services/AuthService";
import ValidationService from "@/services/ValidationService";
import ThemeService from "@/services/ThemeService";
import fs from "@/services/FormatService";
import Utils from "@/services/Utils";

//Components
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import SaveRequiredModal from "@/components/SaveRequiredModal";
import ConfigSelect from "@/components/ConfigSelect";
import ThemeSelect from "@/components/ThemeSelect";

var schoolDashAccessLevels = [
	{ name: "School", id: 0, sequence: 1 },
	{ name: "District", id: 1, sequence: 2 },
	{ name: "All", id: 2, sequence: 3 },
];

export default {
	name: "TenantEdit",

	components: {
		EditPane,
		SaveOptionalModal,
		SaveRequiredModal,
		ConfigSelect,
		ThemeSelect,
	},

	props: ["user", "params", "query"],

	data() {
		return {
			fs: fs,
			tab: 1,
			mode: "",
			client: {},
			loading: true,
			sRole: {},
			themes: [],
			selectedTheme: {},
			successMsg: "",
			errMsg: "",
			dirty: false,

			schoolDashAccessLevels: schoolDashAccessLevels,

			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {},

			saveReqModal: false,
			saveReqAction: "continue",
			saveReqNext: () => {},
		};
	},

	created() {
		this.loadData();
		this.initValidation();
	},

	watch: {
		"sRole.page_config_tenants": function (newVal, oldVal) {
			if (newVal && !this.sRole.page_config_current_tenant) {
				console.log("FU", newVal, !this.sRole.page_config_current_tenant);
				this.sRole.page_config_current_tenant = true;
			}
		},
		"sRole.page_config_current_tenant": function (newVal, oldVal) {
			if (!newVal && this.sRole.page_config_tenants) {
				console.log("BAR", newVal, this.sRole.page_config_tenants);
				this.sRole.page_config_tenants = false;
			}
		},
		sRole: {
			handler: function (newVal, oldVal) {
				if (newVal && oldVal && newVal.id == oldVal.id) {
					if (newVal.access < 0) {
						this.sRole.access = 0;
					}
					if (newVal.access > this.user.role.access) {
						this.sRole.access = this.user.role.access;
					}
				}
			},
			deep: true,
		},
	},

	computed: {
		orderedRoles() {
			return _.orderBy(this.client.roles, ["access", "name"], ["desc", "asc"]);
		},
		accessibleRoles() {
			return _.filter(this.client.roles, (role) => {
				return this.user.role.access >= role.access;
			});
		},
		duplicates() {
			let indexMap = {};
			_.each(this.orderedRoles, (role, i) => {
				if (!indexMap[role.id]) {
					indexMap[role.id] = [];
				}
				indexMap[role.id].push(i);
			});

			let dupes = [];
			_.each(indexMap, (indices) => {
				if (indices.length > 1) {
					_.each(indices, (index) => {
						dupes[index] = true;
					});
				}
			});
			return dupes;
		},
	},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				// name: {
				// 	group: "main",
				// 	errorMsg: "Each role must have a unique Reference ID",
				// 	func: () => {
				// 		return this.duplicates.length == 0;
				// 	}
				// }
			});
		},

		blankClient() {
			return {
				roles: [
					RoleService.getPrefillRole("DIRECTOR"),
					RoleService.getPrefillRole("ADMIN"),
					RoleService.getPrefillRole("RESOLUTION"),
					RoleService.getPrefillRole("TEAM_LEAD"),
					RoleService.getPrefillRole("SCORER"),
					RoleService.getPrefillRole("BASIC_SCORER"),
				],
				alerts: [],
				credentials: [],
			};
		},

		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"client",
				(newc, old) => {
					console.log(newc, old);
					console.log("marking dirty");
					this.dirty = true;
				},
				{ deep: true }
			);
		},

		loadData() {
			this.dirty = false;

			ThemeService.getThemes().then((themes) => {
				this.themes = themes;
			});

			return TenantService.getClient().then((resp) => {
				this.client = resp.data;
				if (this.client.roles.length > 0) {
					this.sRole = _.find(_.orderBy(this.client.roles, ["access", "name"], ["desc", "asc"]), (role) => {
						return this.user.role.access >= role.access;
					});
					this.loading = false;
					this.refresh = new Date();
					this.watchChanges();
				}
			});
		},

		saveClient() {
			AuthService.queueRefresh();
			if (this.reacceptTerms) {
				this.client.terms_updated_at = moment();
			}
			return TenantService.saveClient(this.client)
				.then((resp) => {
					notie.success("Tenant saved");
					if (this.client.id != resp.data.id) {
						this.$router.replace("/tenants/" + resp.data.id);
					}
					// else {
					// 	this.$router.replace(
					// 		"/tenants/" +
					// 			resp.data.id +
					// 			"?rand=" +
					// 			Math.floor(Math.random() * 1000000)
					// 	);
					// }
					this.loadData();
					ThemeService.refresh();
				})
				.catch((err) => {
					notie.error("Failed to save tenant", err);
				});
		},

		hasAccess(role) {
			return role && this.user.role.access >= role.access;
		},

		addRole() {
			this.client.roles.push({
				new: true,
				id: Utils.generateUUID(),
				name: "New Role",
				access: 0,
				theme: "info",
			});
			this.sRole = this.client.roles[this.client.roles.length - 1];
		},

		removeRole(role) {
			TenantService.canDeleteRole(role.id)
				.then((resp) => {
					if (resp.data) {
						this.client.roles = _.without(this.client.roles, role);
					} else {
						notie.error("This role is in use and cannot be deleted");
					}
				})
				.catch((err) => {
					notie.error("Failed to determine if role can be deleted", err);
				});
		},

		isRoleActive(role) {
			return role === this.sRole;
		},

		isDuplicate(role, i) {
			return this.duplicates[i] && role.new;
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/vues/UserMgmt/RolesEdit.vue